import BackofficeIndexBase from './BackofficeIndexBase';

export default class BackofficeOrdersIndex extends BackofficeIndexBase {
  constructor() {
    super("#orders-datatable");

    this.bindEvents();
  }

  bindEvents() {
    $('#saveOrderStep').off('click').on('click', function(event) {
      event.preventDefault(); 

      const url = $(this).data('url');
     
      $.ajax({
        url: url,
        type: 'PUT',
        contentType: 'application/json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          application.successNotification("Filtre sauvegardé");
          
          // add class disabled to button
          $('#saveOrderStep').addClass('disabled');
        },
        error: function(error) {
          application.errorNotification("Erreur lors de la sauvegarde du filtre");
        }
      });
    });

    // Handle global Excel export using the button with data-url
    $('#export-global-excel').off('click').on('click', function(event) {
      event.preventDefault();
      const url = $(this).data('url');
      
      application.openLoader();
      
      $.ajax({
        url: url,
        type: 'GET',
        xhrFields: {
          responseType: 'blob'
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(blob) {
          application.closeLoader();
          
          const currentDate = new Date().toLocaleDateString('fr-FR').replace(/\//g, '');
          const fileName = `orders_global_export_${currentDate}.xlsx`;
          
          // Create a blob URL and trigger download
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          
          // Clean up
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        },
        error: function(error) {
          application.closeLoader();
          application.errorNotification("Erreur lors de l'export global Excel");
        }
      });
    });
  }

  onDataChanged(data) {
    // Custom logic for orders
  }
}